// extracted by mini-css-extract-plugin
export default {"btn":"GrayButton_btn__YXYyt"};